<template>
    <div class="w-100">

<div class="w-100" v-if="field.type == 'text'">

    <v-text-field 
        :label="field.label" 
        :required="field.required" 
        :rules="(field.required) ? [rules.required] : []"
        :name="field.name"
        :readonly="readonly"
        variant="outlined"
        v-model="formVal[field.name]">
    </v-text-field>

</div>
<div class="w-100" v-else-if="field.type == 'email'">

    <v-text-field 
        :label="field.label" 
        append-inner-icon="mdi-email"
        :required="field.required" 
        :rules="(field.required) ? [rules.email] : []"
        :readonly="readonly"
        :name="field.name"
        variant="outlined"
        v-model="formVal[field.name]">
    </v-text-field>

</div>

<div class="w-100" v-else-if="field.type == 'date'">

    <date-picker 
        @update="setDate(field.name, $event)"
        :value="datePicker[field.name]"
        :label="field.label" 
        :required="field.required" 
        >
    </date-picker>

</div>

<div class="w-100 pb-6" v-else-if="field.type == 'date-range'">

    <range-date-picker 
        @update="setDates(field.name, $event)"
        :preValue="{start: null, end: null}"
        :label="field.label" 
        >
    </range-date-picker>

</div>

<div class="w-100" v-else-if="field.type == 'phone'">

    <v-text-field 
        :label="field.label" 
        append-inner-icon="mdi-phone"
        :required="field.required" 
        :rules="(field.required) ? [rules.phone] : []"
        :name="field.name"
        :readonly="readonly"
        variant="outlined"
        v-model="formVal[field.name]">
    </v-text-field>

</div>

<div class="w-100" v-else-if="field.type == 'textarea'">

    <v-textarea 
        :label="field.label" 
        :required="field.required" 
        :rules="(field.required) ? [rules.required] : []"
        :name="field.name"
        :readonly="readonly"
        variant="outlined"
        v-model="formVal[field.name]">
    </v-textarea>

</div>

<div class="w-100" v-else-if="field.type == 'checkbox'">

    <v-checkbox 
        v-model="formVal[field.name]"
        :name="field.name"
        :readonly="readonly"
        :rules="(field.required) ? [rules.required] : []"
        :required="field.required" 
    >
        <template v-slot:label>
            <div class="text-white">
               {{ field.label}}<br>
                <a @click.stop v-if="field.label_url" :href="field.label_url" target="_blank" rel="noopener noreferrer">
                    {{ field.label_url_text }}
                </a>
            </div>
        </template>
    </v-checkbox>

</div>

<div class="w-100" v-else-if="field.type == 'file'">
    <v-file-input
    :rules="(field.required) ? [rules.filerule] : []"
    accept="application/pdf"
    :label="field.label" 
    variant="outlined"
    :required="field.required" 
    v-model="formVal[field.name]"
    prepend-icon="mdi-file"
    :readonly="readonly"
  ></v-file-input>

</div>

<div class="w-100" v-else-if="field.type == 'mouths-select'">
   
    <v-select
        :label="field.label" 
        append-inner-icon="mdi-calendar"
        :required="field.required" 
        :rules="(field.required) ? [rules.required] : []"
        :readonly="readonly"
        :items="months"
        variant="outlined"
        v-model="formVal[field.name]"
    >
    </v-select>

</div>

<div class="w-100" v-else-if="field.type == 'car_types'">
   
   <v-select
       :label="field.label" 
       :required="field.required" 
       :rules="(field.required) ? [rules.required] : []"
       :readonly="readonly"
       return-object
       :items="types"
       item-value="label"
       clearable
       item-title="label"
       variant="outlined"
       v-model="formVal[field.name]"
   >
   </v-select>

</div>

<div class="w-100" v-else-if="field.type == 'car_brands'">
   
   <v-select
       :label="field.label" 
       :required="field.required" 
       :rules="(field.required) ? [rules.required] : []"
       :readonly="readonly"
       :items="brands"
       return-object
       clearable
       item-title="name"
       variant="outlined"
       v-model="formVal[field.name]"
   >
   </v-select>

</div>


<div class="w-100" v-else-if="field.type == 'car_models'" >

    <!-- formVal.car_type: {{ formVal.car_type }}<br>
    formVal.car_brand: {{ formVal.car_brand }}<br> -->

    <div :key="formVal.car_type+'-'+formVal.car_brand">
        <v-select
            :label="field.label" 
            :required="field.required" 
            :rules="(field.required) ? [rules.required] : []"
            clearable
            :readonly="readonly"
            :items="filteredModels(models)"
            :item-title="item => `${item.brand} - ${item.name}`"
            return-object
            variant="outlined"
            v-model="formVal[field.name]"
        >
        </v-select>
    </div>
</div>


<div v-else class="w-100 pb-3">
    {{ field }} TBD
</div>

    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import rangeDatePicker from '@/components/AdvancedFields/rangeDatePicker.vue'
import datePicker from '@/components/AdvancedFields/datePicker.vue'
import {validateEmail, validatePhone } from "@/plugins/validationFunctions.js"


export default{
    name: "fieldForm",
    components:{
        'range-date-picker':rangeDatePicker,
        'date-picker':datePicker,
    },
    props:{
        field:{
            required: true,
        },
        readonly:{
            required: false,
            type: Boolean,
            default: false
        },
        formVal:{
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            brands: 'carsDrive/brands',
            types: 'carsDrive/types',
            models: 'carsDrive/models',
        }),
    },
    data: () => ({
      name: '',
      months: [],
      menu: false,
      max: null,
      min: null,
      datePicker: {},
      rules: {
        email: value => validateEmail(value) || 'attributes.email.validation.email',
        phone: value => validatePhone(value) || 'attributes.phone.validation.phone',
        required: value => !!value || 'attributes.generic.validation.required',
        filerule: [
            value => !!value || 'File is required',
            files => !files || !files.some(file => file.size > 2097152) || 'File size should be less than 2 MB!',
        ],
      },
    }),
    mounted(){
        this.rules = {
            email: value => validateEmail(value) || this.translate('attributes.email.validation.email'),
            phone: value => validatePhone(value) || this.translate('attributes.phone.validation.phone'),
            required: value => !!value || this.translate('attributes.generic.validation.required'),
        }
        this.months = Array.from({length: 18}, (_, i) => i + 1 +' '+  this.translate('attributes.months.label'))

        this.min = this.$moment().add(1,'days').format('YYYY-MM-DD');
        this.max = this.$moment().add(1,'year').format('YYYY-MM-DD');

    },
    methods:{
        translate(string){
            return this.$vuetify.locale.t(string)
        },
        setDate(value, date){
            // console.log('setDate',value)
            // console.log('setDate',date)
            // eslint-disable-next-line vue/no-mutating-props
            this.formVal[value] = date
        },
        setDates(value, dates){
            // eslint-disable-next-line vue/no-mutating-props
            this.formVal[value] = {
                start : dates.startDate,
                end : dates.endDate
            }
        },
        updateDate(value, date){
            // console.log('updateDate',value)
            // console.log('updateDate',date)
            // eslint-disable-next-line vue/no-mutating-props
            this.formVal[value] = this.$moment(date).format('ddd DD MMMM yyyy')

        },  
        filteredModels(array){

            let types = [];
            let brands = [];

            if(this.formVal.car_type){
                types = [this.formVal.car_type.id];
            }
            if(this.formVal.car_brand){
                brands = [this.formVal.car_brand.id];
            }


            // console.log(' filteredModels types',types)
            // console.log(' filteredModels brands',brands)

            if(types.length){
                array = array.filter( i => types.includes( i.typeId ) );
            }
            if(brands.length){
                array = array.filter( i => brands.includes( i.brandId ) );
            }

            // console.log('filteredModels',array)

            return array
        }
    }
}
</script>